import { render, staticRenderFns } from "./BInputPhone.vue?vue&type=template&id=4c627313&"
import script from "./BInputPhone.vue?vue&type=script&lang=js&"
export * from "./BInputPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports